import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecurrenceEditorComponent } from './recurrenceeditor.component';
import { RecurrenceEditorModule } from './recurrenceeditor.module';
/**
 * NgModule definition for the RecurrenceEditor component with providers.
 */
export class RecurrenceEditorAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, RecurrenceEditorModule],
    exports: [
        RecurrenceEditorModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RecurrenceEditorAllModule_tsickle_Closure_declarations() {
/** @type {?} */
RecurrenceEditorAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RecurrenceEditorAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
